import request from '@/libs/request'

// 活动列表
// activityType 活动类型 1 固定 2临时
// consumeMoneyCondition价格筛选条件 1:1-100 2:101-200 3.免费(单位：元) 不传为全部
// dateCondition日期筛选条件 1:近一周 2:近一个月 3:近三个月 不传为全部
// integralCondition积分筛选条件 1:1-50 2:51-100 3:101分以上 不传为全部
// keyWords 活动名称
// typeId 类别id (移动端这加个类型 key：0L value：临时活动)
// unionId工会id
export const activityList = (data) => {
  return request({
    url: '/fixedactivity/mobileList',
     data,
    method: 'post'
  })
}

export const unionPullList = (data) => {
  return request({
    url: '/union/queryPullList',
     data,
    method: 'post'
  })
}

export const actDetail = (data) => {
  return request({
    url: '/fixedactivity/mobileQueryInfoById',
     data,
    method: 'post'
  })
}





